import { writable } from "svelte/store"
/**
 * @typedef {Object} cursorPosition - temp store for cursor positions
 * @type {Object}
 * temp store for cursor positions
 *
 * @property {Number} x - Processed x Position
 * @property {Number} y - Processed y Position
 * @property {Number} originalX - Actual x Position (offsetX)
 * @property {Number} originalY - Actual y Position (offsetY)
 */
/**
 * @type {import("svelte/store").Writable<cursorPosition>}
 */
const cursorPosition = writable({
  x: 0,
  y: 0,
  originalX: 0,
  originalY: 0,
})
export default cursorPosition
